import React, { MouseEventHandler } from 'react';
import useHover from '../../hooks/useHover';
import './MarkerEmoji.scss';

type MarkerEmojiProps = {
  lat: number;
  lng: number;
  data: {
    emoji: string;
    description: string;
    isHighlighted: boolean | undefined;
  };
  onClick?: MouseEventHandler<HTMLDivElement>;
};

function MarkerEmoji({
  data: { emoji, description, isHighlighted = false },
  onClick,
}: MarkerEmojiProps) {
  const { isHovered, hoverProps } = useHover();

  return (
    <>
      <div
        className='marker-emoji-container'
        {...hoverProps}
        onClick={onClick}
      >
        <div className='marker-emoji-pin'>
          {isHighlighted ? (
            <img
              className='marker-emoji'
              alt={description}
              src='/svgs/map-marker-highlighted.svg'
            />
          ) : (
            <img
              className='marker-emoji'
              alt={description}
              src='/svgs/map-marker.svg'
            />
          )}
        </div>
        <span className='market-emoji-text'>{emoji}</span>
      </div>
      {(isHovered || isHighlighted) && (
        <div className='marker-description-container'>
          <span>
            {description.length > 37 ? `${description.substring(0, 37)}...` : description}
          </span>{' '}
        </div>
      )}
    </>
  );
}

MarkerEmoji.displayName = 'MarkerEmoji';
export default MarkerEmoji;
